import { render, staticRenderFns } from "./PublishingStatementsBankFileDialog.vue?vue&type=template&id=58391cb0"
import script from "./PublishingStatementsBankFileDialog.vue?vue&type=script&lang=js"
export * from "./PublishingStatementsBankFileDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports